import React from 'react';
import gql from 'graphql-tag';
import { ChildProps } from 'react-apollo';
import { WithRouterProps, withRouter } from 'react-router';

import Item2FeedbackItem, { Item2FeedbackItemFragment } from './item2_feedback_item';
import { Item2SellerReviews, core_apimessages_Feedback_Type } from '../schemas/rql';
import { getOffsetFromPage } from '../pagination_helpers';

import RQLPagination from '@reverbdotcom/commons/src/components/rql_pagination';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { connect } from '@reverbdotcom/commons/src/connect';

interface ExternalProps {
  sellerUuid: string;
  type: core_apimessages_Feedback_Type;
}

type IProps = ChildProps<ExternalProps & WithRouterProps, Item2SellerReviews.Query, Location>;

const REVIEWS_LIMIT = 5;

function getAdditionalParamValue(props: IProps) {
  if (props.type === core_apimessages_Feedback_Type.RECEIVED) return 'all';
  return props.type.toLowerCase();
}

function getReviewsPageNumberFromURL(props: IProps) {
  const urlParams = new URLSearchParams(props.location.search);
  return urlParams.get('page');
}

export function Item2FeedbackList(props: IProps) {
  if (props.data.loading) { return null; }
  const { user } = props.data;

  function renderPagination() {
    return (
      <div className="align-center scaling-mt-3">
        <RQLPagination
          limit={REVIEWS_LIMIT}
          offset={getOffsetFromPage(getReviewsPageNumberFromURL(props), REVIEWS_LIMIT)}
          total={user.feedback.total}
          paginationWindow={2}
          anchor="shop-reviews"
          pageParam="page"
          replaceHistory
          additionalParamValue={getAdditionalParamValue(props)}
          additionalParam="filter"
          trackInMParticle
        />
      </div>
    );
  }

  return (
    <div>
      {user.feedback.feedbacks.map((feedback, index) => {
        return (
          <Item2FeedbackItem
            feedback={feedback}
            key={index}
          />
        );
      })}
      {renderPagination()}
    </div>
  );
}

const withQuery = withGraphql<IProps, Item2SellerReviews.Query>(
  gql`
    query Item2_Seller_Reviews(
      $sellerUuid: String
      $type: core_apimessages_Feedback_Type
      $limit: Int
      $offset: Int
    ){
      user(input: { uuid: $sellerUuid }) {
        _id
        feedback(input: { limit: $limit, offset: $offset, type: $type }) {
          total
          feedbacks {
            ...Item2FeedbackItemData
          }
        }
        shop(input: { channel: REVERB }) {
          slug
        }
      }
    }
    ${Item2FeedbackItemFragment}
  `,
  {
    options: (ownProps) => {
      return {
        ssr: false,
        errorPolicy: 'all',
        variables: {
          sellerUuid: ownProps.sellerUuid,
          type: ownProps.type,
          limit: REVIEWS_LIMIT,
          offset: getOffsetFromPage(new URLSearchParams(ownProps.location.search).get('page'), REVIEWS_LIMIT),
        },
      };
    },
  },
);

export default connect<ExternalProps>([
  withRouter,
  withQuery,
])(Item2FeedbackList);
